import { type BookingRevision } from '@/lib/bookings';
import { formatDateTime } from '@/lib/format';
import { RevisionStatusBadge } from '@/components/StatusBadges';

export function RevisionsTimeline({ revisions }: { revisions: BookingRevision[] }) {
  return (
    <section>
      <h2 className="mb-3 text-base font-semibold text-[var(--text-heading)]">Channel revisions</h2>
      {revisions.length === 0 ? (
        <p className="text-sm text-muted">No revisions yet.</p>
      ) : (
        <ol className="space-y-3">
          {revisions.map((rev) => (
            <li key={rev.id} className="rounded-[var(--radius-card)] border border-[var(--border-hairline)] bg-card p-4">
              <div className="mb-2 flex flex-wrap items-center gap-2">
                <RevisionStatusBadge status={rev.revision_status} />
                <span className="text-sm text-muted">
                  Received {formatDateTime(rev.received_at)}
                </span>
              </div>
              <div className="space-y-1 text-sm">
                {rev.acked_at ? (
                  <div className="flex items-center gap-1.5 text-[var(--ollio-success)]">
                    <span aria-hidden="true">✓</span>
                    <span>Acked {formatDateTime(rev.acked_at)}</span>
                  </div>
                ) : (
                  <div className="flex items-center gap-1.5 text-[var(--ollio-warning)]">
                    <span aria-hidden="true">⚠</span>
                    <span>Not yet acked</span>
                  </div>
                )}
                {rev.applied_at && (
                  <div className="flex items-center gap-1.5 text-[var(--ollio-success)]">
                    <span aria-hidden="true">✓</span>
                    <span>Applied {formatDateTime(rev.applied_at)}</span>
                  </div>
                )}
              </div>
              <details className="mt-3">
                <summary className="cursor-pointer select-none text-xs text-muted hover:text-foreground">
                  Raw payload
                </summary>
                <pre className="mt-2 overflow-x-auto rounded-md bg-[var(--surface-sunken)] p-2 text-xs text-foreground">
                  {JSON.stringify(rev.raw_payload, null, 2)}
                </pre>
              </details>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
